module.exports = __webpack_public_path__ + "static/oms-c1bfbd2739a5a4a67691af8fdb1a051a.png";